/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RootInputs */

const en_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Root`)
};

const fr_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Racine`)
};

const de_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wurzel`)
};

const it_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radice`)
};

const ru_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Корень`)
};

const es_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raíz`)
};

const zh_cn2_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根`)
};

const ja_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根`)
};

const hi_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जड़`)
};

const pt_pt2_root = /** @type {(inputs: RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raiz`)
};

/**
* | output |
* | --- |
* | "Root" |
*
* @param {RootInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const root = /** @type {((inputs?: RootInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RootInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_root(inputs)
	if (locale === "de") return de_root(inputs)
	if (locale === "it") return it_root(inputs)
	if (locale === "ru") return ru_root(inputs)
	if (locale === "es") return es_root(inputs)
	if (locale === "zh-CN") return zh_cn2_root(inputs)
	if (locale === "ja") return ja_root(inputs)
	if (locale === "hi") return hi_root(inputs)
	if (locale === "pt-PT") return pt_pt2_root(inputs)
	return en_root(inputs)
});